import React, { useState, useEffect, useMemo } from 'react'
import { connect } from "react-redux";
import TopBarNav from '../common/TopBarNav'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { useHistory } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import * as IndirectActions from '../../actions/indirects/IndirectActions'
import { downloadCSV, getFilteredTableTitle, getTableColumns } from "../common/Utils"
import { IndirectStyles } from './IndirectStyles'
import TableFilterComponent from '../common/TableFilterComponent'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { customStylePrincipal } from '../common/CommonStyles';

const IndirectListByStatus = ({ classes, ...props }) => {
    const history = useHistory()
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [searchButton, setSearchButton] = useState(0)
    const { match: { params } } = props;
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t } = useTranslation()

    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const invoiceComplete = params.status === '27' || params.status === '11' || params.status === '14' ? 'Concluida' : 'lagTime'
    
    const excelConfiguration = [
        {
            selector: 'id',
            label: 'Núm'
        },
        {
            selector: 'orderNumber',
            label: 'Número de orden'
        },
        {
            selector: 'entity',
            label: 'Entidad'
        },
        {
            selector: 'costoCenter',
            label: 'Centro de Costo'
        },
        {
            selector: 'description',
            label: 'Descripción'
        },
        {
            selector: 'supplierName',
            label: 'Proveedor'
        },
        {
            selector: 'amountText',
            label: 'Monto'
        },
        {
            selector: 'currencyId',
            label: 'Moneda'
        },
        {
            selector: 'createDate',
            label: 'Fecha de creación'
        },
        {
            selector: 'maturity',
            label: 'Vigencia de PO'
        },
        {
            selector: 'invoiceStatus',
            label: 'Estatus de Factura'
        },
        {
            selector: invoiceComplete,
            label: 'Días de atraso de factura'
        }
    ]

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/indirect/listByStatus',
            linkLegend: 'Lista',
            urlParams: [{ key: 'status', value: params.status }, { key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Indirect_List(props.userLanguage, props.userToken, params.status, startDate, endDate, filterText, params.branchOfficeId, onError, onSuccess)
        return () => {
            props.cleanUserProfile()
        }
    }, [filterText, searchButton]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        }

        const handleStartDateChange = (e) => {
            if (e != null)
                setStartDate(e.format('YYYY-MM-DD'))
            else
                setStartDate(null)
        }

        const handleEndDateChange = (e) => {
            if (e != null)
                setEndDate(e.format('YYYY-MM-DD'))
            else
                setEndDate(null)
        }

        return <TableFilterComponent
            onFilter={e => setFilterText(e.target.value)}
            onClear={handleClear} filterText={filterText}
            onStartDateChange={handleStartDateChange}
            onEndDateChange={handleEndDateChange}
            onClickSearch={() => setSearchButton(searchButton + 1)}
            onExport={() => downloadCSV(props.listByStatus, excelConfiguration)}
            styles={classes.searchAlign}
        />;
    }, [filterText, resetPaginationToggle, searchButton, props]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}>
                    </Grid>
                </Grid>
                <Grid>
                    <DataTable
                        title={getFilteredTableTitle("Indirect", params.status)}
                        columns={getTableColumns("Indirect", params.status)}
                        data={props.listByStatus}
                        defaultSortField=""
                        customStyles={customStylePrincipal}
                        highlightOnHover
                        responsive
                        striped
                        dense
                        pointerOnHover
                        pagination
                        paginationComponentOptions={paginationOptions}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                    />
                </Grid>
                <br />
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    listByStatus: state.IndirectReducer.IndirectListByStatus,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(IndirectActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(IndirectStyles)(IndirectListByStatus))